import { useState, useCallback } from "react";
import { debounce } from "lodash";
import { fetchDropDownData } from "../fetchDropDownData";

interface SupplierOption {
    label: string;
    value: string;
    currency?: string;
    purchaseCurrencyId?: string;
}

export const SupplierPartUtils = () => {
    const [supplierOptions, setSupplierOptions] = useState<SupplierOption[]>([]);
    const [partNoOptions, setPartNoOptions] = useState<any[]>([]);
    const [gstOptions, setGstOptions] = useState<any[]>([]);

    // 🔹 Fetch suppliers using `fetchDropDownData`
    const fetchSupplierOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/contributors",
                searchKey: "code",
                searchTerm: inputValue,
                labelKey: "code",
                valueKey: "_id",
            }).then((data) => {
                // Filter suppliers who are either SUPPLIER or CUSTOMER&SUPPLIER
                console.log(data);
                

                const filteredSuppliers = data.filter(
                    (supplier: any) => supplier.type === "SUPPLIER" || supplier.type === "CUSTOMER&SUPPLIER"
                );

                // Format supplier options with currency details
                const formattedSuppliers = filteredSuppliers.map((supplier: any) => ({
                    label: supplier.code, // Name of the supplier
                    value: supplier._id, // ID of the supplier
                    currency: supplier.purchaseCurrency?.name || "",
                    purchaseCurrencyId: supplier.purchaseCurrencyId || "",
                }));

                console.log(formattedSuppliers);
                
                setSupplierOptions(formattedSuppliers);
            });
        }, 500),
        []
    );

    const fetchPartOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/items",
                searchKey: "internalPartNo",
                searchTerm: inputValue,
                labelKey: "internalPartNo",
                valueKey: "_id",
            }).then((data) => {
                // Filter suppliers who are either SUPPLIER or CUSTOMER&SUPPLIER

                const filteredOptions = data
                    ?.filter((item: any) => item.purchaseItem === true)
                    .map((item: any) => ({
                        label: item.internalPartNo,  // Part Number as selectable option
                        value: item._id,
                        partNo: item.internalPartNo,  // Store partNo
                        partName: item.partName, // Store partName for autofill
                    }));

                setPartNoOptions(filteredOptions);
            });
        }, 500),
        []
    );

    const fetchGstOptions = useCallback(
        debounce((inputValue) => {
            fetchDropDownData({
                endpoint: "/gstslabs",
                searchKey:"gstName",
                searchTerm: inputValue,
                labelKey: "gstName",
                valueKey: "gstPercentage",
            }).then((data) => {
                // Create dropdown options
                const filteredOptions = data.map((gst: any) => ({
                    label: gst.gstName,
                    value: gst.gstPercentage,
                    sgst: gst.sgst,
                    cgst: gst.cgst,
                    igst: gst.igst,
                })) || [];

                setGstOptions(filteredOptions);
            });
        }, 500),
        []
    );

    return {
        supplierOptions,
        setSupplierOptions,
        fetchSupplierOptions,
        partNoOptions,
        setPartNoOptions,
        fetchPartOptions,
        gstOptions,
        setGstOptions,
        fetchGstOptions
    };
};
